export default __webpack_public_path__ + "static/media/Error404.56b41d46.png";